import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isAdminBrainEnabled } from "@/lib/featureFlags";

/**
 * colivIQ Brain is staff-only (admin / super_admin / tech) and behind
 * VITE_ADMIN_BRAIN. Owners and operators go where /admin/directory sends them.
 */
export function BrainRouteGate({ children }: { children: ReactNode }) {
  const { hasStaffRole, isOwnerPortalOnly, rolesReady } = useAuth();
  if (!isAdminBrainEnabled()) return <Navigate to="/admin" replace />;
  if (!rolesReady) return null;
  if (isOwnerPortalOnly || !hasStaffRole)
    return <Navigate to="/admin/properties" replace />;
  return <>{children}</>;
}
